// src/components/ImageDisplayModal/ImageDisplayModal.tsx
import React from 'react';
import { Modal, Image } from 'antd';
import styles from './index.module.scss';

interface ImageDisplayModalProps {
  isVisible: boolean;
  onClose: () => void;
  imageUrl: string;
  imageAlt: string;
  imageWidth?: string | number; // Modal 的宽度，图片会按原图大小展示，但 Modal 可能会限制其显示区域
  preview?: boolean; // 新增：控制是否允许图片预览，默认为 true
  title?: string;
}

const ImageDisplayModal: React.FC<ImageDisplayModalProps> = ({
  isVisible,
  onClose,
  imageUrl,
  imageAlt,
  imageWidth = 'auto', // 将 Modal 默认宽度改为 'auto'，让内容决定宽度
  preview = true,     // 默认开启预览
  title
}) => {
  return (
    <Modal
      title={title}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={imageWidth} // Modal 的宽度，可以设置为图片的实际宽度或 'auto'
      centered
    >
      <div className={styles.imageWrapper}>
        <Image
          src={imageUrl}
          alt={imageAlt}
          preview={preview} // 将 preview prop 传递给 Ant Design 的 Image 组件
          // 注意：这里不再添加 .modalImage 类来控制 max-width: 100%
          // 图片将尝试以其原始尺寸显示
          // 如果图片超出 Modal 宽度，Modal 会出现滚动条
        />
      </div>
    </Modal>
  );
};

export default ImageDisplayModal;